export default __webpack_public_path__ + "images/52d8e72912cdaf571133b120b4753353-design_small.webp";